import { Component } from './live-codec.js';
export const kartModel = 'models/player/items/taunts/bumpercar/parts/bumpercar.mdl';
export function kartVisualState(entity) {
    const player=entity.state.components[Component.Player];
    if(!player||!(player.state&1)||!((player.conditions?.[2]??0)&(1<<18)))return null;
    return {...entity.state,components:{...entity.state.components,[Component.Appearance]:{
        ...entity.state.components[Component.Appearance],skin:player.team===3?1:0,body:0,model:0},[Component.Player]:undefined,
        [Component.Effects]:undefined,[Component.Parent]:undefined,[Component.Animation]:undefined}};
}

export function poseKart(kart,owner,parenting) {
    if(owner.object.parent&&kart.object.parent!==owner.object.parent)owner.object.parent.add(kart.object);
    owner.object.updateWorldMatrix(true,false);kart.object.position.copy(owner.object.position);kart.object.quaternion.copy(owner.object.quaternion);kart.object.scale.copy(owner.object.scale);
    kart.object.visible=owner.object.visible;kart.object.updateMatrixWorld(true);parenting.merge(kart,owner);
}
